import {useStaticQuery, graphql} from 'gatsby'
import {useEffect} from 'react'
import {useFormikContext} from 'formik'

const getLabelAndValue = (item) => ({
  label: item.name,
  value: item.id,
})

const useHooks = (props) => {
  const query = graphql`
    query {
      defaultDistrict: wpDistrict(slug: {eq: "quan-7"}) {
        id
      }
      categories: allWpProductCategory(
        sort: {fields: date, order: ASC},
      ) {
        edges {
          node {
            id
            name: title
          }
        }
      }
      streets: allWpStreet(sort: {fields: title, order: ASC}) {
        edges {
          node {
            id
            name: title
          }
        }
      }
      districts: allWpDistrict(sort: {fields: title, order: ASC}) {
        edges {
          node {
            id
            name: title
          }
        }
      }
      wards: allWpWard(sort: {fields: title, order: ASC}) {
        edges {
          node {
            id
            name: title
            acf {
              district {
                ... on WpDistrict {
                  id
                }
              }
            }
          }
        }
      }
      directions: allWpDirection(sort: {fields: date, order: ASC}) {
        edges {
          node {
            id
            name: title
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)

  const categories = data.categories.edges.map((edge) => edge.node)
  const districts = data.districts.edges.map(({node}) => ({
    ...node,
    wards: data.wards.edges
      .map((edge) => edge.node)
      .filter((ward) => ward.acf.district.id === node.id),
  }))
  const streets = data.streets.edges.map((edge) => edge.node)
  const directions = data.directions.edges.map((edge) => edge.node)
  const {
    values: {district},
  } = props

  let wardOptions = []
  const foundDistrict = districts.find((dist) => dist.id === district)

  if (foundDistrict) {
    wardOptions = foundDistrict.wards.map(getLabelAndValue)
  }

  let disabledSearchBtn = true
  Object.values(props.values).some((value) => {
    if (value) {
      disabledSearchBtn = false

      return true
    }

    return false
  })

  const {setFieldValue} = useFormikContext()

  useEffect(() => {
    setFieldValue('district', data.defaultDistrict.id)
  }, [data.defaultDistrict.id, setFieldValue])

  return {
    disabledSearchBtn,
    isDistrictNotSet: !district,
    categoryOptions: categories.map(getLabelAndValue),
    districtOptions: districts.map(getLabelAndValue),
    wardOptions,
    streetOptions: streets.map(getLabelAndValue),
    directionOptions: directions.map(getLabelAndValue),
    priceOptions: [
      {
        label: 'Dưới 3 tỷ',
        value: ',3000000000',
      },
      {
        label: '3 tỷ - 6 tỷ',
        value: '3000000000,6000000000',
      },
      {
        label: '6 tỷ - 9 tỷ',
        value: '6000000000,9000000000',
      },
      {
        label: '9 tỷ - 15 tỷ',
        value: '9000000000,15000000000',
      },
      {
        label: '15 tỷ - 20 tỷ',
        value: '15000000000,20000000000',
      },
      {
        label: 'Trên 20 tỷ',
        value: '20000000000,',
      },
    ],
  }
}

export default useHooks
